module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/supplier-list/supplier-list.component.scss
// module id = 1513
// module chunks = 0